import OmnitechApp from './omnitech-app'
import withComposedProvider from './with-composed-provider'

export default function createOmnitechApp() {
  // apply the providers for all modules
  return withComposedProvider(OmnitechApp)
}
